import { httpsCallable } from "firebase/functions";
import React, { useContext, useEffect, useState } from "react";
import { functions } from "../../../../Firebase";
import { ReactComponent as EndQuizPass } from "./icons/endQuizPass.svg";
import { ItemContext } from "../Context/ItemContext";
import { getCookie } from "../../../../Cookies";
import { Box, Button } from "@mui/material";
import { IP } from "../../../../baseUrlAndConfig";
import axios from "axios";

import { color } from "@mui/system";
import HrloadingScreen from "../../../LodingHrscreen";
import gifimg from "../../With Text.gif";
import downloadimg from "../../Download.svg";
import {
  buildCertificateUrl,
  buildLinkedInAddToProfileUrl,
} from "../../../../utilities/Certificate/certificate.utils";
import { LinkedIn, Share as ShareIcon } from "@material-ui/icons";
import { toast } from "react-toastify";
const Node = ({ node, setCanNavigate, courseStatus, certificateInfo }) => {
  const { courseId, isLinear, progressIndex } = useContext(ItemContext);

  const [progress, setProgress] = useState(null);
  const [isNodeComplete, setIsNotComplete] = useState(false);

  const [lodingscreen, setlodingscreen] = useState(false);
  const [cirtificategen, setcertificategen] = useState("");
  useEffect(() => {
    let timesNow = new Date();
    setCanNavigate(true);
    //console.log(isLinear);
    if (!isLinear) {
      if (node.nodeType == "topic") {
        let configrecrut = {
          method: "get",

          url: `${IP}/userItemDetails/nodeProgress`,
          params: { courseId: courseId, topicId: node.id },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("bearer")}`,
          },
          data: "dataregionf",
        };
        axios(configrecrut).then((result) => {
          setProgress(result.data);
          if (result.data.completed == result.data.total) {
            setIsNotComplete(true);

            let configrecruttopic = {
              method: "patch",

              url: `${IP}/userProgress/topic`,
              // params: {  courseId: courseId,
              //   topicId: node.id, },
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("bearer")}`,
              },
              data: JSON.stringify({
                courseId: courseId,
                topicId: node.id,
                lastVisited: timesNow.toString(),
              }),
            };
            axios(configrecruttopic);
          }
        });
      } else if (node.nodeType == "lesson") {
        let configrecrut = {
          method: "get",

          url: `${IP}/userItemDetails/nodeProgress`,
          params: { courseId: courseId, topicId: node.id },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("bearer")}`,
          },
          data: "dataregionf",
        };
        axios(configrecrut).then((result) => {
          setProgress(result.data);
          if (result.data.completed == result.data.total) {
            setIsNotComplete(true);
            //alert("lesson sent")

            let configrecruttopic = {
              method: "patch",

              url: `${IP}/userProgress/lessons`,
              // params: {  courseId: courseId,
              //   topicId: node.id, },
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("bearer")}`,
              },
              data: JSON.stringify({
                courseId: courseId,
                lessonId: node.id,
                lastVisited: timesNow.toString(),
              }),
            };
            axios(configrecruttopic);

            // alert("lesson sent")

            let configLessonCom = {
              method: "post",

              url: `${IP}/userNotification/lessonCompletedUserNotification`,
              // params: {  courseId: courseId,
              //   topicId: node.id, },
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("bearer")}`,
              },
              data: JSON.stringify({
                id: node.id,
                uid: getCookie("UID"),
              }),
            };
            axios(configLessonCom);
          }
        });
      } else if (node.nodeType == "course") {
        //console.log("calling getNodeProgress");
        let configrecrut = {
          method: "get",

          url: `${IP}/userItemDetails/nodeProgress`,
          params: { courseId: courseId },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("bearer")}`,
          },
          data: "dataregionf",
        };
        axios(configrecrut).then((result) => {
          //console.log(result.data.completed, result.data.total);
          setProgress(result.data);
          if (result.data.completed == result.data.total) {
            //console.log(result.data.completed, result.data.total);
            setIsNotComplete(true);

            let configrecrut = {
              method: "patch",

              url: `${IP}/userProgress/`,
              params: { courseId: courseId },
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("bearer")}`,
              },
              data: JSON.stringify({
                completionDate: timesNow.toString(),
                courseId: courseId,
              }),
            };
            axios(configrecrut);
            setlodingscreen(true);
            let configGeneCerti = {
              method: "post",

              url: `${IP}/certificate/certificate`,
              params: { courseId: courseId },
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("bearer")}`,
              },
              data: JSON.stringify({
                courseId: courseId,
                completionDate: timesNow.toString(),
              }),
            };
            axios(configGeneCerti)
              .then((res) => {
                setlodingscreen(false);
                setcertificategen(res.data.link);
              })
              .catch((er) => {
                setlodingscreen(false);
              });
          }
        });
      }
      return;
    }
    if (node.nodeType == "topic") {
      let configGeneCerti = {
        method: "patch",

        url: `${IP}/userProgress/topic`,
        params: { courseId: courseId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("bearer")}`,
        },
        data: JSON.stringify({
          courseId: courseId,
          topicId: node.id,
          lastVisited: timesNow.toString(),
        }),
      };
      axios(configGeneCerti);
    } else if (node.nodeType == "lesson") {
      let configGeneCerti = {
        method: "patch",

        url: `${IP}/userProgress/lessons`,
        params: { courseId: courseId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("bearer")}`,
        },
        data: JSON.stringify({
          courseId: courseId,
          lessonId: node.id,
          lastVisited: timesNow.toString(),
        }),
      };
      axios(configGeneCerti);

      let configLessonCom = {
        method: "post",

        url: `${IP}/userNotification/lessonCompletedUserNotification`,
        // params: {  courseId: courseId,
        //   topicId: node.id, },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("bearer")}`,
        },
        data: JSON.stringify({
          id: node.id,
          uid: getCookie("UID"),
        }),
      };
      axios(configLessonCom);
    } else if (node.nodeType == "course") {
      let configLessonCom = {
        method: "patch",

        url: `${IP}/userProgress`,
        // params: {  courseId: courseId,
        //   topicId: node.id, },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("bearer")}`,
        },
        data: JSON.stringify({
          completionDate: timesNow.toString(),
          courseId: courseId,
        }),
      };
      axios(configLessonCom);
      setlodingscreen(true);
      let configGeneCerti = {
        method: "post",

        url: `${IP}/certificate/certificate`,
        params: { courseId: courseId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("bearer")}`,
        },
        data: JSON.stringify({
          courseId: courseId,
          completionDate: timesNow.toString(),
        }),
      };
      axios(configGeneCerti)
        .then((res) => {
          setcertificategen(res.data.link);

          setlodingscreen(false);
        })
        .catch((er) => {
          setlodingscreen(false);
        });
    }
  }, [progressIndex]);

  const [certificateData, setCertificateData] = useState(null);
  async function fetchData() {
    let configrecrutci = {
      method: "get",

      url: `${IP}/userCourse/courseCertificate`,
      params: { courseId: courseId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: "dataregionf",
    };
    axios(configrecrutci).then((result) => {
      if (result?.data?.error) {
        return;
      }
      setCertificateData(result?.data);
    });
  }

  useEffect(() => {
    if (cirtificategen) fetchData();
  }, [cirtificategen]);

  const handleShareCertificate = async () => {
    const certUrl = certificateInfo ? certificateInfo : cirtificategen;
    const certName = certificateData?.certificateName || "Course Certificate";
    const crtLink = buildCertificateUrl(certificateData?.certificateId);
    if (navigator.share) {
      try {
        await navigator.share({
          title: certName,
          text: `I just earned my ${certName}! Check out my certificate.`,
          url: crtLink,
        });
      } catch (err) {
        if (err.name !== "AbortError") {
          toast.error("Failed to share certificate");
        }
      }
    } else {
      try {
        await navigator.clipboard.writeText(crtLink);
        toast.success("Certificate link copied to clipboard!");
      } catch (err) {
        toast.error("Failed to copy link");
      }
    }
  };

  return (
    <>
      <HrloadingScreen open={lodingscreen} />

      {isLinear || isNodeComplete ? (
        <div className="node-container">
          {/* <EndQuizPass /> */}
          {node?.nodeType !== "course" && (
            <>
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "40px",
                  fontWeight: "600",
                }}
              >
                Congratulations!
              </p>
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "20px",
                  fontWeight: "400",
                  color: "black",
                }}
              >
                You have completed a {node.nodeType}
              </p>
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "20px",
                  fontWeight: "400",
                }}
              >
                {node.name}
              </p>
            </>
          )}

          {(cirtificategen ? cirtificategen : certificateInfo) &&
            !lodingscreen &&
            node.nodeType == "course" && (
              <div>
                {" "}
                <img src={gifimg} width="90%" />
              </div>
            )}

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignContent: "center",
              justifyContent: "center",
              width: "90%",
              gap: "12px",
              margin: "20px auto auto auto",
            }}
          >
            {(cirtificategen ? cirtificategen : certificateInfo) &&
              !lodingscreen &&
              node.nodeType == "course" && (
                <Button
                  variant="outlined"
                  onClick={() => {
                    window.open(
                      certificateInfo ? certificateInfo : cirtificategen,
                      "_blank",
                    );
                  }}
                  sx={{
                    flex: "1 1 calc(33.33% - 12px)",
                    minWidth: "140px",
                    height: "44px",
                    borderColor: "#6846C7",
                    color: "#6846C7",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                    gap: "8px",
                    "&:hover": {
                      borderColor: "#6846C7",
                      bgcolor: "rgba(104, 70, 199, 0.1)",
                    },
                    "@media (max-width: 480px)": {
                      flex: "1 1 calc(50% - 10px)",
                      fontSize: "12px",
                      height: "40px",
                    },
                  }}
                >
                  Download
                  <img
                    src={downloadimg}
                    style={{
                      display: "inline",
                      marginLeft: "6px",
                      width: "16px",
                      height: "16px",
                    }}
                  />
                </Button>
              )}

            {(cirtificategen ? cirtificategen : certificateInfo) &&
              !lodingscreen &&
              node.nodeType == "course" && (
                <Button
                  variant="outlined"
                  onClick={handleShareCertificate}
                  sx={{
                    flex: "1 1 calc(33.33% - 12px)",
                    minWidth: "140px",
                    height: "44px",
                    borderColor: "#6846C7",
                    color: "#6846C7",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                    gap: "8px",
                    "&:hover": {
                      borderColor: "#6846C7",
                      bgcolor: "rgba(104, 70, 199, 0.1)",
                    },
                    "@media (max-width: 480px)": {
                      flex: "1 1 calc(50% - 10px)",
                      fontSize: "12px",
                      height: "40px",
                    },
                  }}
                >
                  Share
                  <ShareIcon sx={{ marginLeft: "6px", fontSize: "18px" }} />
                </Button>
              )}

            {(cirtificategen ? cirtificategen : certificateInfo) &&
              !lodingscreen &&
              node.nodeType == "course" && (
                <Button
                  variant="contained"
                  href={buildLinkedInAddToProfileUrl({
                    name: certificateData?.certificateName,
                    issuedOn: certificateData?.issuedOn,
                    expiry: certificateData?.expiry,
                    certId: certificateData?.certificateId,
                  })}
                  sx={{
                    flex: "1 1 calc(33.33% - 12px)",
                    minWidth: "140px",
                    height: "44px",
                    bgcolor: "#5B2DAB",
                    display: "flex",
                    borderRadius: "8px",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    color: "white",
                    boxShadow: "none",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "600",
                    "& .MuiTypography-root": {
                      WebkitTextFillColor: "white !important",
                    },
                    "&:hover": {
                      bgcolor: "#5B2DAB",
                      boxShadow: "none",
                    },
                    "@media (max-width: 480px)": {
                      flex: "1 1 calc(50% - 10px)",
                      fontSize: "12px",
                      height: "40px",
                    },
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedIn sx={{ color: "white" }} />
                  <p
                    style={{
                      fontFamily: "Poppins",
                      color: "white",
                      WebkitTextFillColor: "white",
                    }}
                  >
                    LinkedIn
                  </p>
                </Button>
              )}
          </div>
        </div>
      ) : progress ? (
        <div className="node-container">
          {/* <EndQuizPass /> */}
          <p
            style={{
              fontFamily: "Poppins",
              fontSize: "40px",
              fontWeight: "600",
            }}
          >
            You have completed {progress.completed} out of {progress.total} in{" "}
            {node.nodeType}
          </p>
          <p
            style={{
              marginTop: "24px",

              fontFamily: "Poppins",
              fontSize: "20px",
              fontWeight: "400",
            }}
          >
            {node.name}
          </p>
        </div>
      ) : (
        ""
      )}
    </>
    // <>
    //   <HrloadingScreen open={lodingscreen} />

    //   {isLinear || isNodeComplete ? (
    //     <div className="node-container">
    //       <EndQuizPass />
    //       <p
    //         style={{
    //           fontFamily: "Poppins",
    //           fontSize: "40px",
    //           fontWeight: "600",
    //         }}
    //       >
    //         Congratulations! You have completed a {node.nodeType}
    //       </p>
    //       <p
    //         style={{
    //           fontFamily: "Poppins",
    //           fontSize: "20px",
    //           fontWeight: "400",
    //         }}
    //       >
    //         {node.name}
    //       </p>

    //       {certificateInfo ||
    //         (certificategen && !lodingscreen && (
    //           <p
    //             style={{
    //               color: "#fff",
    //               fontSize: "20px",
    //               marginTop: "50px",

    //               fontFamily: "Poppins",
    //               fontSize: "14px",
    //               fontWeight: "500",
    //             }}
    //             onClick={() => {
    //               window.open(
    //                 certificateInfo ? certificateInfo : certificategen,
    //                 "_blank"
    //               );
    //             }}
    //           >
    //             {" "}
    //             Download certificate
    //           </p>
    //         ))}
    //     </div>
    //   ) : progress ? (
    //     <div className="node-container">
    //       {/* <EndQuizPass /> */}
    //       <p
    //         style={{
    //           fontFamily: "Poppins",
    //           fontSize: "40px",
    //           fontWeight: "600",
    //         }}
    //       >
    //         You have completed {progress.completed} out of {progress.total} in{" "}
    //         {node.nodeType}
    //       </p>
    //       <p
    //         style={{
    //           marginTop: "24px",

    //           fontFamily: "Poppins",
    //           fontSize: "20px",
    //           fontWeight: "400",
    //         }}
    //       >
    //         {node.name}
    //       </p>
    //     </div>
    //   ) : (
    //     ""
    //   )}
    // </>
  );
};

export default Node;
